import { NeedlMenuItem as Item } from '@/components/Atoms/Menu/RadixMenu';
import type { ResultType } from '@/components/SourceCards/components/common';
import {
  useCreateSummaryHandler,
  useShowSummarize,
} from '@/features/Summarisation/hooks';

const SummarizationItem = (props: SummarizationItemImplType) => {
  const showSummarize = useShowSummarize({
    source: props?.result?.source,
    form_ua: props?.result?.form_ua,
  });

  if (!showSummarize) {
    return null;
  }

  return <SummarizationItemImpl {...props} />;
};

const SummarizationItemImpl = ({ result }: SummarizationItemImplType) => {
  const {
    createSummary,
    disabled,
    isSummaryGenerated,
    isGeneratingSummary,
    handleViewSummary,
  } = useCreateSummaryHandler({
    deeplink: result?.deeplink,
    source: result?.source,
  });

  const clickHandler = () => {
    if (disabled) {
      return;
    }

    if (isSummaryGenerated) {
      handleViewSummary();
    } else {
      createSummary();
    }
  };

  return (
    <Item disabled={disabled} onClick={clickHandler}>
      {isGeneratingSummary
        ? 'Summarizing'
        : isSummaryGenerated
        ? 'View Summary'
        : 'Summarize'}
    </Item>
  );
};

type SummarizationItemImplType = ResultType;

export { SummarizationItem };
